var _g, _path, _path2, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 214,
    viewBox: "0 0 238 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    width: 127.534,
    height: 70.7481,
    rx: 16,
    transform: "matrix(-0.839946 -0.542671 -0.542671 0.839946 226.426 72.2088)",
    fill: "#1792B9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 13",
    x: 183.148,
    y: 128.947,
    width: 118.561,
    height: 68.104,
    rx: 16,
    transform: "rotate(-147.134 183.148 128.947)",
    fill: "url(#camera_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    x: 90.1708,
    y: 70.4067,
    width: 40.5381,
    height: 28.9816,
    rx: 14.4908,
    transform: "rotate(-57.1344 90.1708 70.4067)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 13",
    cx: 108.861,
    cy: 66.8743,
    rx: 10.1345,
    ry: 10.5388,
    transform: "rotate(-57.1344 108.861 66.8743)",
    fill: "#1792B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 117.991,
    cy: 52.7436,
    rx: 5.06726,
    ry: 5.26938,
    transform: "rotate(-57.1344 117.991 52.7436)",
    fill: "#1792B9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shade",
    d: "M73.0001 135.601C73.4993 142.484 61 153.101 43 153.101C20 155.601 9.49923 144.383 8.99996 137.5C8.50069 130.617 19.9422 123.101 42.0001 123.101C63 123.101 72.5008 128.718 73.0001 135.601Z",
    fill: "#1792B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "light",
    d: "M72.9999 137.5L72.6401 138.18C69.9511 143.259 65.704 147.342 60.5228 149.829C57.5334 151.264 54.3042 152.133 50.9985 152.392L36.8463 153.502C32.6549 153.831 28.4394 153.347 24.4316 152.077L22.4802 151.458C20.6165 150.868 18.8535 149.997 17.2518 148.876L13.6476 146.353C9.07093 143.149 7.02979 137.396 8.5645 132.024C9.48618 128.798 11.6106 126.049 14.4997 124.344L88.8796 80.4325C91.4361 78.9232 94.5969 78.8649 97.2073 80.2789C101.451 82.5775 102.914 87.9554 100.419 92.0868L72.9999 137.5Z",
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 35",
    d: "M60.7401 39.7394L65.7397 37.7396L67.7395 32.74L69.7393 37.7396L74.7389 39.7394L69.7393 41.7392L67.7396 46.7388L65.7397 41.7392L60.7401 39.7394Z",
    fill: "#FAC830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 35_2",
    d: "M64.4811 25.4811L74.4812 21.4811L78.4811 11.481L82.4811 21.481L92.4811 25.4811L82.4811 29.4811L78.4812 39.481L74.4812 29.4811L64.4811 25.4811Z",
    fill: "#FAC830"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "camera_linear",
    x1: 242.428,
    y1: 128.947,
    x2: 242.428,
    y2: 197.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6473F6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7d7466ca.svg";
export { ForwardRef as ReactComponent };